import { ApiClient } from "@/api-client/src/core/api-client";
import { BrandRelatedRespone, TopBrandResponse } from "@/packages/types/brands";

const apiClient = new ApiClient();
const webService = apiClient.web;

export interface HomeBrandSectionData {
  id: number;
  title: string;
  subtitle?: string;
  brands: {
    id: number;
    name: string;
    slug: string;
    logoFileName?: string;
    logoUrl?: string;
    bannerFileName?: string;
    bannerUrl?: string;
  }[];
}

export interface HomeBrandSectionsResponse {
  status: string;
  message: string;
  data: HomeBrandSectionData[];
}

export const fetchTopBrands = async (): Promise<TopBrandResponse> => {
  const response = await webService.get<TopBrandResponse>(`/home-brands`);
  return response;
};

export const fetchHomeBrandSections = async (): Promise<HomeBrandSectionsResponse> => {
  const response = await webService.get<HomeBrandSectionsResponse>(`/home-page-sections?type=BRANDS`);
  return response;
};

export const fetchBrandBySlug = async (
  slug: string
): Promise<BrandRelatedRespone> => {
  const response = await webService.get<BrandRelatedRespone>(`/brands/${slug}`);
  return response;
};
